/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const system   = {
  flashMessage : ''
}
const userInfo = null
const companyInfo = {
  data : { 
    fiscal : {
      endereco : {
        
      }
    } 
  }
}
const translation = {
  language : 'pt-BR'
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : userInfo, // null is user is not resolved yet, undefiend once is resolved as not logged in
    AppActiveCompany        : companyInfo,
    system                  : system,
    isNewUser               : false, // For registering purposes
    translation             : translation,
    bodyOverlay             : false,
    isVerticalNavMenuActive : false,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    pageIntent              : null, // in case of a user try to navigate to some page wihout been authenticated, is stored here for redirection
    isLoadingSession        : true,
    error                   : null,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
